<template>
    <div
        class="assignment"
        v-if="partIn.list_items.length > 0">
        <h5 class="title">{{ partIn.name }}</h5>
        <design-2021-group-results-standard-list-component
            v-if="partIn.type_name === 'assignment_standard_list'"
            :part-in="partIn">
        </design-2021-group-results-standard-list-component>

        <design-2021-group-results-color-list-component
            v-else-if="partIn.type_name === 'assignment_color_list'"
            :part-in="partIn">
        </design-2021-group-results-color-list-component>

        <design-2021-group-results-check-list-component
            v-else-if="partIn.type_name === 'assignment_check_list'"
            :part-in="partIn">
        </design-2021-group-results-check-list-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-results-part-component',
    props: {
        partIn: {
            type: Object,
        },
    },
};
</script>

<style scoped lang="scss">
::v-deep .not-found {
    &.result-list {
        padding: map-get($grid-gutter-spacing, 'twenty-one');
    }
}
</style>
